import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@fleetminder/ui/styles.css";

import { App } from "./app.js";

const root = document.getElementById("root");

if (!root) {
  throw new Error("FleetMinder root element was not found.");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
